import { Box } from '@factorialco/deprecated-design-system'
import ProjectsUpsellBannerImage from 'assets/images/project_management/banners/projects_upsell_banner.svg'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { UpsellProjectsBannerDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface UpsellProjectsBannerProps {
  bannerFeatureId?: Features
  requestSource: string
  localStorageKey: string
}

const UpsellProjectsBanner = ({
  bannerFeatureId = Features.projects_core,
  requestSource,
  localStorageKey,
}: UpsellProjectsBannerProps) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const [upsellProjectsBannerIsHidden, setUpsellProjectsBannerIsHidden] =
    useLocalStorage<boolean>(localStorageKey)

  const handleClose = () => {
    setUpsellProjectsBannerIsHidden(true)
  }

  const { data } = useQuery(UpsellProjectsBannerDocument, {
    variables: {
      companyId: companyId,
      featureIds: [bannerFeatureId],
    },
  })

  const isFeatureEnabled = !!data?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === bannerFeatureId
  )?.available

  if (isFeatureEnabled || upsellProjectsBannerIsHidden) return null

  return (
    <Box paddingBottom="s24">
      <UpsellingKit.ProductBanner
        moduleRequested={AvailableModules.projects}
        featureRequested={bannerFeatureId}
        requestSource={requestSource}
        requestReason={ValidReasons.MissingFeature}
        title={i18n.t('project_management.upsell_banner.title')}
        subtitle={i18n.t('project_management.upsell_banner.subtitle')}
        mediaUrl={ProjectsUpsellBannerImage}
        onClose={handleClose}
        primaryAction={{
          label: i18n.t('project_management.upselling.cta'),
          variant: 'outline',
        }}
      />
    </Box>
  )
}

export default UpsellProjectsBanner
